export const SearchBox = () => {
    const btnHiddenClass = 'field--hidden'
    const searchForm = document.getElementById('search-form')
    const searchField = document.getElementById('search')
    const submitBtn = document.getElementById('search-submit')
    const submitReset = document.getElementById('search-reset')
    const currentSearchQuery = searchField.value

    // reset need to empty the field, not reset the current query 
    searchField.removeAttribute('value')
    searchField.value = currentSearchQuery

    function toggleResetAndSearchBtn( force = false ){
        const showSubmit = (searchField.value !== currentSearchQuery || searchField.value === '' || force )
        submitBtn.classList.toggle(btnHiddenClass, !showSubmit)
        submitReset.classList.toggle(btnHiddenClass, showSubmit)
    }

    searchForm.addEventListener('reset', () => toggleResetAndSearchBtn(true) )
    searchField.addEventListener('keyup', () => toggleResetAndSearchBtn() )
    toggleResetAndSearchBtn()
    


}